import React from 'react';

const ChevronDownIcon = ({ color }) => {
  return (
    <svg width="12" height="6" viewBox="0 0 12 6" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M0 0.575195H12L5.841 5.5752L0 0.575195Z" fill={color}/>
    </svg>
  )
};

export default ChevronDownIcon;